import getFlattenedFiles from '@picsart/cloud-storage/api/getFlattenedFiles';
import type { IFile } from '@picsart/cloud-storage/types/core/types/files/file';

import { ErrorMessages } from '@/consts/errors';
import { getCloudStorageHeaders, withCloudStorageErrorHandling } from './utils';

type Params = {
  toolId: string;
  limit?: number;
  offset?: number;
};

type GetDriveFilesResult = {
  files: IFile[];
  hasMore: boolean;
};

const getDriveFiles = async ({
  toolId,
  limit = 30,
  offset = 0,
}: Params): Promise<GetDriveFilesResult | null> => {
  const result = await withCloudStorageErrorHandling({
    operation: () =>
      getFlattenedFiles({
        headers: getCloudStorageHeaders(),
        params: { limit: String(limit), offset: String(offset) },
        attributes: { tool: toolId },
      }),
    errorMessage: ErrorMessages.loadDriveFiles,
  });

  if (!result) return null;

  const files = (result.response ?? []) as IFile[];
  return { files, hasMore: files.length === limit };
};

export type { GetDriveFilesResult };

export default getDriveFiles;
